import {Injectable} from '@angular/core';
import {ObjectValidators} from '@aviary/forms/extensions/form-extensions.types';
import {CreateItemRequestValue} from '@store/item-requests/item-requests.types';
import {Validators} from '@angular/forms';

@Injectable({providedIn: 'root'})
export class ItemRequestsValidators {
  public readonly createItemRequest: ObjectValidators<CreateItemRequestValue> = {
    itemTitle: [Validators.required, Validators.maxLength(512)],
    itemAuthor: [Validators.required, Validators.maxLength(512)],
    requestedBranchId: [],
    isbn: [Validators.maxLength(64)],
    materialTypeDesc: [Validators.maxLength(128)],
    yearOfPublication: [Validators.maxLength(128)],
    printType: [Validators.maxLength(128)],
    notes: [Validators.maxLength(512)],
    confirmCheckbox: [Validators.requiredTrue]
  };
}
